import React, { useState } from "react";
import styled from "styled-components";

interface ToggleButtonProps {
  toggleOn:any;
  setToggleOn:any;
  toggle1: any;
  toggle2: any;
  defaultOn?: boolean;
  onToggle?: (isOn: boolean) => void;
}

const ToggleButton: React.FC<ToggleButtonProps> = ({
  toggleOn,
  setToggleOn,
  defaultOn = true,
  onToggle,
  toggle1,
  toggle2,
}) => {
  // const [isOn, setIsOn] = useState(defaultOn);

  const handleToggle = () => {
    const newIsOn = !toggleOn;
    setToggleOn(!toggleOn);
    if (onToggle) {
      onToggle(newIsOn);
    }
  };

  return (
    <Style>
      <div className="toggleWrap">
        <button
          onClick={() => handleToggle()}
          className={toggleOn ? "active" : ""}
          style={{
            borderTopLeftRadius: "10px",
            borderBottomLeftRadius: "10px",
          }}
        >
          {toggle1}
        </button>
        <button
          onClick={() => handleToggle()}
          className={!toggleOn ? "active" : ""}
          style={{
            borderTopRightRadius: "10px",
            borderBottomRightRadius: "10px",
          }}
        >
          {toggle2}
        </button>
      </div>
    </Style>
  );
};

export default ToggleButton;

const Style = styled.div`
  .toggleWrap {
    display: flex;
  }
  button {
    flex: 1;
    padding: 20px;
    font-size: 16px;
    font-weight: 500;
    outline: none;
    color: #cecece;
    border: 2px solid #cecece;
    margin: -1px;
    font-size: 24px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
  }
  .active {
    color: #4dd2ae;
    border-color: #4dd2ae;
    z-index:2;
  }
`;
